import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Col, Empty, List, notification, Row, Skeleton, Typography} from 'antd';
import queryString from 'query-string';
import {authenticationUtils} from '../../../utils/common';
import {getRedirect, performSearch} from '../../../actions/search.actions';
import './SearchPage.css';

// import Highlighter from "react-highlight-words";

const {Paragraph } = Typography;

const SearchPage = props => {
    const query = queryString.parse(props.location.search).query;
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [token, setToken] = useState();
    const [loading, setLoading] = useState(true);
    const { performSearch, isSearching, getRedirect, results, redirectUrlProp } = props;

    useEffect(() => {
        setRedirectUrl(redirectUrlProp);
    }, [redirectUrlProp]);

    useEffect(() => {
        if (redirectUrl !== null) {
            window.open(redirectUrl);
            setRedirectUrl(null);
        }
    }, [redirectUrl]);

    useEffect(() => {
        authenticationUtils.getUserToken().then(setToken);
        displayNotification();
    }, []);

    useEffect(() => {
        const fetchResults = term => {
            if (token !== undefined) {
                performSearch({ term: term, token: token });
            }
        };
        if (query !== undefined && query !== '') {
            fetchResults(query);
        }
    }, [performSearch, query, token]);

    useEffect(() => {
        setLoading(isSearching);
    }, [isSearching, setLoading]);

    const displayNotification = () => {
        notification["warning"]({
            message: 'Accessing DMS Documents',
            duration: 60,
            description: <>Due to technical constraints please ensure that you allow DMS (BC's Document Management System) to access your Google account by logging in on the new tab appearing and subsequently clicking 'Allow'.</>
        });
    };

    const createResultsDMS = () => {
            return (
                <List locale = {{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No results found" />}}
                    itemLayout="horizontal"
                    dataSource={results.dmsResults}
                    split={false}
                    pagination={{
                        pageSize: 10,
                        hideOnSinglePage: true
                    }}
                    grid={{
                        gutter: 8,
                        sm: 1,
                        md: 1,
                        xl: 1
                    }}
                    renderItem={item => (
                        <List.Item className="listItem" >
                            <Card
                                size="small"
                                title={
                                    <span style={{ cursor: 'pointer', color: '#1890ff' }} className="pageTitle" onClick={() => getRedirect({ item: item, isAttachment: false })}>
                                        {item.title}
                                    </span>
                                }>
                                <Paragraph style={{ marginBottom: 0 }} ellipsis>
                                    <b>Location:</b> {item.dms}/{item.instance}
                                </Paragraph>
                            </Card>
                        </List.Item>
                    )}
                />
            );

    };

    const filterCmsResults = () => {
        let term = query.endsWith("s") ? query.slice(0, -1) : query;

        const cmsResults = results.cmsResults;
        return cmsResults.filter(res => (res.title.toLocaleLowerCase().includes(term) || res.content.toLowerCase().includes(term)));
    }

    const createResultsCMS = () => {
        const filteredResults = filterCmsResults();
            return (
                <List locale = {{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No results found" />}}
                    itemLayout="horizontal"
                    dataSource={filteredResults}
                    split={false}
                    pagination={{
                        pageSize: 10,
                        hideOnSinglePage: true
                    }}
                    grid={{
                        gutter: 8,
                        sm: 1,
                        md: 1,
                        xl: 1
                    }}
                    renderItem={item => (
                        <List.Item className="listItem">
                            <Card
                                size="small"
                                title={
                                    <Link to={item.path + "?query=" + query} className="pageTitle">
                                        {item.title}
                                    </Link>
                                }>
                                <Paragraph style={{ marginBottom: 0 }} ellipsis>
                                    {item.description}
                                </Paragraph>
                            </Card>
                        </List.Item>
                    )}
                />
            );
    };

    function removeDuplicates(array) {
        let uniq = {};
        return array.filter(obj => !uniq[obj.title] && (uniq[obj.title] = true))
    }

    const createResultsDMSAttachments = () => {
            return (
                <List locale = {{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No results found" />}}
                    itemLayout="horizontal"
                    dataSource={removeDuplicates(results.dmsAttachResults)}
                    split={false}
                    pagination={{
                        pageSize: 10,
                        hideOnSinglePage: true
                    }}
                    grid={{
                        gutter: 8,
                        sm: 1,
                        md: 1,
                        xl: 1
                    }}
                    renderItem={item => (
                        <List.Item className="listItem">
                            <Card
                                size="small"
                                title={
                                    <span style={{ cursor: 'pointer', color: '#1890ff' }} className="pageTitle" onClick={() => getRedirect({ item: item, isAttachment: false })}>
                                        {item.title}
                                    </span>
                                }>
                                {/*<Paragraph style={{ marginBottom: 4 }} ellipsis>*/}
                                    {/*{item.documentType}*/}
                                {/*</Paragraph>*/}
                                <Paragraph style={{ marginBottom: 0 }} ellipsis>
                                    <b>Location:</b> {item.dms}/{item.instance}
                                </Paragraph>
                            </Card>
                        </List.Item>
                    )}
                />
            );
    };

    return (
        <div className="pageContent">
            <Row className="searchPage-row">
                <Col span={24}>
                    <h1 className="ant-typography">Search results</h1>
                </Col>
            </Row>
            <Row className="searchPage-row">
                <Col sm={{ span: 24 }} lg={{ span: 8 }}>
                    <div className="ant-list-header">
                        <h3 className="ant-typography">Title and Tag of DMS document</h3>
                    </div>
                    {!loading ? createResultsDMS() : null}
                </Col>
                <Col sm={{ span: 24 }} lg={{ span: 8 }}>
                    <div className="ant-list-header">
                        <h3 className="ant-typography">Title and content of webpage</h3>
                    </div>
                    {!loading ? createResultsCMS() : null}
                </Col>
                <Col sm={{ span: 24 }} lg={{ span: 8 }}>
                    <div className="ant-list-header">
                        <h3 className="ant-typography">Content of DMS document</h3>
                    </div>
                    {!loading ? createResultsDMSAttachments() : null}
                </Col>
            </Row>
            {loading ? <Skeleton paragraph={{ rows: 15 }} active /> : null}
        </div>
    );
};

const mapStateToProps = state => ({
    isSearching: state.search.isSearching,
    results: state.search.results,
    redirectUrlProp: state.search.redirectUrl
});

const mapDispatchToProps = {
    performSearch,
    getRedirect
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchPage);
